module.exports = __webpack_public_path__ + "img/un-petit-jeu-sans-consequence.daec50c5.jpg";